export default __webpack_public_path__ + "static/media/emptyStar.d05d63c2.svg";